// extracted by mini-css-extract-plugin
export default {"wrapper":"UpdateRegionalCalendarFooter_wrapper__Aud+t","actionsBtnBlock":"UpdateRegionalCalendarFooter_actionsBtnBlock__34WrP"};